import React from 'react';
import { imgIconStandingsBracketSvg } from '~/src/images';
import PlayoffsTable from '../Standings/PlayoffsTable';
import './Playoffs.scss';

const Playoffs = () => {
	return (
		<>
			<div className="Playoffs Phase ">
				<div className="Primary">Group Stage</div>
				<div className="Secondary">
					<div className="Location">
						<div className="City">Miami, FL</div>
						<div className="Date">Fri, Jun 27 - Sat, Jun 28</div>
					</div>
					<a className="StandingsLink" href="/standings/playoffs/tournament">
						<div>
							<img src={imgIconStandingsBracketSvg} />
							Brackets
						</div>
					</a>
				</div>
			</div>
			<PlayoffsTable />
			{/* <div className="ButtonContainer">
				<div className="Button">View Bracket</div>
			</div> */}
			<div className="Footnotes">
				{/* <div className="Icon">
						<img src={imgIconGoldenTicketSvg} alt="Golden Ticket" />
					</div>
					<div className="Text">Denotes Golden Ticket Winner</div> */}
			</div>
		</>
	);
};

export default Playoffs;
